import {businessInterface} from "../interfaces/businessInterface";

export const actionSetAuth = (payload: businessInterface) =>
  ({
    type: 'AUTH',
    payload,
  } as const);

export const actionSetLogout = () =>
  ({
    type: 'LOGOUT'
  } as const);
